import { MasterOfActsAPI } from "../../api/api";
import { idGenerator } from "../../utils/chartDataCorrectors";

const SUCCESS_LOAD_COMPANIES = "chartReducer/SUCCESS_LOAD_COMPANIES";
const SUCCESS_LOAD_TOP = "chartReducer/SUCCESS_LOAD_TOP";
const FETCH_COMPANIES = "chartReducer/FETCH_COMPANIES";
const ERROR_LOAD_COMPANIES = "chartReducer/ERROR_LOAD_COMPANIES";
const SET_SELECTED_COMPANIES = "chartReducer/SET_SELECTED_COMPANIES";
const SET_START_TIME = "chartReducer/SET_START_TIME";
const SET_END_TIME = "chartReducer/SET_END_TIME";

const initialState = {
  companies: [],
  selectedCompany: null,
  startTime: "2023.01.01",
  endTime: "2023.10.01",
  loading: true,
  error: null,
  topList: [],
};

export const companyChartReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUCCESS_LOAD_TOP:
      return {
        ...state,
        topList: action.topList,
        loading: false,
      };
    case SUCCESS_LOAD_COMPANIES:
      return {
        ...state,
        companies: action.companies,
        loading: false,
      };
    case FETCH_COMPANIES:
      return {
        ...state,
        loading: true,
      };
    case ERROR_LOAD_COMPANIES:
      return {
        ...state,
        loading: false,
        error: "Что-то пошло не так... Попробуйте перезагрузить страницу",
      };
    case SET_SELECTED_COMPANIES:
      return {
        ...state,
        selectedCompany: action.selectedCompany,
        loading: false,
      };
    case SET_START_TIME:
      return {
        ...state,
        startTime: action.startTime,
        loading: false,
      };
    case SET_END_TIME:
      return {
        ...state,
        endTime: action.endTime,
        loading: false,
      };
    default:
      return state;
  }
};

export const selectCompany = (state) => state.companyChartReducer;

export const successLoadCompanies = (companies) => ({
  type: SUCCESS_LOAD_COMPANIES,
  companies,
});

export const successLoadTop = (topList) => ({
  type: SUCCESS_LOAD_TOP,
  topList,
});

export const fetchCompanies = () => ({ type: FETCH_COMPANIES });
export const errorLoadCompanies = () => ({ type: ERROR_LOAD_COMPANIES });
export const setSelectedCompanies = (selectedCompany) => ({
  type: SET_SELECTED_COMPANIES,
  selectedCompany,
});

export const setStartTime = (startTime) => ({
  type: SET_START_TIME,
  startTime,
});

export const setEndTime = (endTime) => ({
  type: SET_END_TIME,
  endTime,
});

export const loadingChartCompanies =
  (startTime, endTime, company) => async (dispatch) => {
    dispatch(fetchCompanies());
      const response = await MasterOfActsAPI.getCompaniesChart(
        startTime,
        endTime,
        company
      );
      //    let response = { data : JSON.parse(rdata),status : 200}
      

      
      if (response.status === 200 && response.data.length !== 0) {
        const new_data = idGenerator(response.data?.local_companies);

        dispatch(successLoadCompanies(new_data));
        const new_data2 = response.data?.popular_violations;

        dispatch(successLoadTop(new_data2));
        dispatch(setStartTime(response.data?.start_time));
        dispatch(setEndTime(response.data?.end_time));
        dispatch(setSelectedCompanies(new_data[0]));
      } else {
        dispatch(errorLoadCompanies());
      }
    
  };